module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[88]575.a278a3f.woff2";